
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projetos/[slug]",
      function () {
        return require("private-next-pages/projetos/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projetos/[slug]"])
      });
    }
  